module.exports = __webpack_public_path__ + "img/dixie-mechanical-logo.7cacfc06.jpg";